import React from 'react';

const Service: React.FC = () => {
  return (
    <div className="container-fluid service py-5">
      <div className="container py-5">
        <div className="mx-auto text-center wow fadeIn" data-wow-delay="0.1s" style={{ maxWidth: '700px' }}>
          <h4 className="text-primary mb-4 border-bottom border-primary border-2 d-inline-block p-2 title-border-radius">Giá trị Trung tâm</h4>
        </div>
        <div className="row g-5">
          <div className="col-md-8 col-lg-8 col-xl-4 wow fadeIn" data-wow-delay="0.5s">
            <div className="text-center border-primary border bg-white service-item">
              <div className="service-content d-flex align-items-center justify-content-center p-4">
                <div className="service-content-inner">
                  <div className="p-4"><i className="fas fa-users fa-6x text-primary"></i></div>
                  <a href="#" className="h4">Giáo Viên Chất Lượng</a>
                  <p className="my-3">Alana chú trọng vào chất lượng giảng dạy và đội ngũ giáo viên có kinh nghiệm tại Trung tâm Anh ngữ Alana. Đảm bảo rằng mỗi học viên không chỉ học từ những người giáo viên có kiến thức chuyên môn sâu rộng mà còn được hỗ trợ và tạo điều kiện để phát triển toàn diện.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8 col-lg-8 col-xl-4 wow fadeIn" data-wow-delay="0.3s">
            <div className="text-center border-primary border bg-white service-item">
              <div className="service-content d-flex align-items-center justify-content-center p-4">
                <div className="service-content-inner">
                  <div className="p-4"><i className="fas fa-sort-alpha-down fa-6x text-primary"></i></div>
                  <a href="#" className="h4">Chương Trình A {'->'} Z</a>
                  <p className="my-3">Chúng tôi tự hào về chương trình học toàn diện từ A đến Z, giúp học viên hiểu sâu và linh hoạt áp dụng kiến thức tiếng Anh. Chương trình của chúng tôi được thiết kế cân nhắc để đáp ứng đa dạng nhu cầu học tập và phát triển cá nhân của mỗi học viên.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8 col-lg-8 col-xl-4 wow fadeIn" data-wow-delay="0.1s">
            <div className="text-center border-primary border bg-white service-item">
              <div className="service-content d-flex align-items-center justify-content-center p-4">
                <div className="service-content-inner">
                  <div className="p-4"><i className="fas fa-gamepad fa-6x text-primary"></i></div>
                  <a href="#" className="h4">Học và Chơi</a>
                  <p className="my-3">Chúng tôi tin rằng học và chơi là hai yếu tố quan trọng để tạo nên môi trường học tập tích cực. Tại Trung tâm Anh ngữ Alana, chúng tôi kết hợp giáo dục với hoạt động giải trí và trò chơi sáng tạo để kích thích sự tò mò và niềm vui trong quá trình học tiếng Anh.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service; 